import { Dialog, DialogContent, DialogContentText, DialogTitle, IconButton } from "@mui/material";
import { memo } from "react";

import useTranslate from "../hooks/use-translate.hook";
import ChatClipboard from "./chat-clipboard.component";
import EmailIcon from "@mui/icons-material/Email";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import CloseIcon from "@mui/icons-material/Close";

const SUPPORT_EMAIL = "suporte_leadstation@syonet.com";

const Chat = ({ open, onClose }) => {
    const t = useTranslate();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md">
            <DialogTitle sx={{ m: 0, p: 2 }}>
                {t("layout:chat.title")}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText style={{ marginBottom: "4px" }}>
                    {t("layout:chat.description")} <strong>{SUPPORT_EMAIL}</strong>
                    {" "}
                    <ChatClipboard email={SUPPORT_EMAIL} />
                </DialogContentText>
                <DialogContentText style={{ marginBottom: "16px" }}>
                    {t("layout:chat.help")}
                </DialogContentText>

                <DialogContentText style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                    <EmailIcon fontSize="small"/>
                    {t("layout:chat.helpEmail")}
                </DialogContentText>
                <DialogContentText style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <LightbulbIcon fontSize="small"/>
                    {t("layout:chat.tip")}
                </DialogContentText>
            </DialogContent>
        </Dialog>);
};

export default memo( Chat );